/* tslint:disable */
/* eslint-disable */
/* @relayHash afe7ac9c677871ad5d6ef4c23759b8b5 */

import { ConcreteRequest } from "relay-runtime";
export type MODERATION_QUEUE = "PENDING" | "REPORTED" | "UNMODERATED" | "%future added value";
export type ModerateCountsCommentEnteredSubscriptionVariables = {
    storyID?: string | null;
    siteID?: string | null;
};
export type ModerateCountsCommentEnteredSubscriptionResponse = {
    readonly commentEnteredModerationQueue: {
        readonly queue: MODERATION_QUEUE;
    };
};
export type ModerateCountsCommentEnteredSubscription = {
    readonly response: ModerateCountsCommentEnteredSubscriptionResponse;
    readonly variables: ModerateCountsCommentEnteredSubscriptionVariables;
};



/*
subscription ModerateCountsCommentEnteredSubscription(
  $storyID: ID
  $siteID: ID
) {
  commentEnteredModerationQueue(storyID: $storyID, siteID: $siteID) {
    queue
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteID"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v2 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "siteID",
                    "variableName": "siteID"
                },
                {
                    "kind": "Variable",
                    "name": "storyID",
                    "variableName": "storyID"
                }
            ],
            "concreteType": "CommentEnteredModerationQueuePayload",
            "kind": "LinkedField",
            "name": "commentEnteredModerationQueue",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "queue",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ModerateCountsCommentEnteredSubscription",
            "selections": (v2 /*: any*/),
            "type": "Subscription",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ModerateCountsCommentEnteredSubscription",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "afe7ac9c677871ad5d6ef4c23759b8b5",
            "metadata": {},
            "name": "ModerateCountsCommentEnteredSubscription",
            "operationKind": "subscription",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'c104649f6f78defb78451efd5625b0c0';
export default node;
